export const CHECKOUT_ACCOUNT_BACK_BUTTON = "checkoutAccountBackButton";
export const CHECKOUT_BACK_BUTTON = "checkoutBackButton";
export const EVENT_CATEGORY_CHECKOUT_ACCOUNT_BACK_BUTTON = "Checkout_Account";
